'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _Functions = require('../core/Functions');

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _Links = require('../utils/Links');

var _TabIndex = require('../utils/TabIndex');

var _LinkConstants = require('./LinkConstants');

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

var _Translatable = require('../decorators/Translatable');

var _Translatable2 = _interopRequireDefault(_Translatable);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getClassName = function getClassName(className, disabled, underline, use) {
  return (0, _reactUtils.classNames)('private-link', _LinkConstants.UNDERLINE_CLASSES[underline], _LinkConstants.USE_CLASSES[use], { 'private-link--disabled': disabled }, className);
};

var renderExternalLinkIcon = function renderExternalLinkIcon(external, I18n, iconProps) {
  if (!external) return null;

  // Opening links in a new window is an accessibility anti-pattern.
  // To mitigate this, we add accessible text in the icon to warn that
  // the link will be opened in a new window
  // @link http://diveintoaccessibility.info/day_16_not_opening_new_windows.html

  var className = (0, _reactUtils.classNames)('private-link--external__icon', iconProps.className);

  return _react2.default.createElement(_UIIcon2.default, _extends({}, iconProps, {
    'aria-label': I18n.text('salesUI.UILink.externalTitle'),
    className: className,
    name: _icons2.default.EXTERNALLINK
  }));
};

var UILink = _react2.default.createClass({
  displayName: 'UILink',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    external: _react.PropTypes.bool.isRequired,
    href: _validHref2.default,
    I18n: _react.PropTypes.object,
    iconProps: _react.PropTypes.object.isRequired,
    onClick: _react.PropTypes.func,
    onKeyDown: _react.PropTypes.func,
    rel: _react.PropTypes.string,
    tabIndex: _react.PropTypes.number,
    target: _react.PropTypes.string,
    truncate: _react.PropTypes.bool.isRequired,
    truncateStringProps: _react.PropTypes.object.isRequired,
    underline: _react.PropTypes.bool.isRequired,
    use: _react.PropTypes.oneOf(Object.keys(_LinkConstants.USE_CLASSES)).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      external: false,
      iconProps: {},
      truncate: false,
      truncateStringProps: {},
      underline: false,
      use: 'dark'
    };
  },
  handleKeyDown: function handleKeyDown(evt) {
    // Simulate click on Enter/Spacebar, to emulate button behavior
    var key = evt.key;


    if (typeof this.props.onClick !== 'function') {
      return;
    }

    if (key === 'Enter' || key === ' ') {
      this.props.onClick(evt);
      evt.preventDefault();
    }
  },
  handleClick: function handleClick(evt) {
    var _props = this.props,
        onClick = _props.onClick,
        disabled = _props.disabled;


    if (disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        className = _props2.className,
        disabled = _props2.disabled,
        external = _props2.external,
        href = _props2.href,
        I18n = _props2.I18n,
        iconProps = _props2.iconProps,
        __onClick = _props2.onClick,
        __onKeyDown = _props2.onKeyDown,
        rel = _props2.rel,
        tabIndex = _props2.tabIndex,
        target = _props2.target,
        truncate = _props2.truncate,
        truncateStringProps = _props2.truncateStringProps,
        underline = _props2.underline,
        use = _props2.use,
        rest = _objectWithoutProperties(_props2, ['children', 'className', 'disabled', 'external', 'href', 'I18n', 'iconProps', 'onClick', 'onKeyDown', 'rel', 'tabIndex', 'target', 'truncate', 'truncateStringProps', 'underline', 'use']);

    /* eslint-disable react/prop-types */


    if (this.props.to != null) {
      _devLogger2.default.warn({
        message: 'UILink: The `to` prop is a no-op. Did you mean `href`? (`to="' + this.props.to + '"`)',
        key: 'UILink: to'
      });
    }
    /* eslint-enable react/prop-types */

    var computedTarget = (0, _Links.getTarget)(external, target);
    var computedRel = (0, _Links.getRel)(rel, computedTarget);
    var externalLinkIcon = renderExternalLinkIcon(external, I18n, iconProps);

    (0, _Links.warnIfShouldBeExternal)(external, computedTarget, 'UILink');

    var wrappedChildren = truncate ? _react2.default.createElement(
      _UITruncateString2.default,
      _extends({
        useFlex: true,
        fixedChildren: externalLinkIcon
      }, truncateStringProps),
      children
    ) : children;

    var renderedLink = _react2.default.createElement(
      'a',
      _extends({}, rest, {
        className: getClassName(className, disabled, underline, use),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        href: disabled ? undefined : (0, _UnsafeUrl.getSafeUrl)(href),
        rel: computedRel,
        role: href ? undefined : 'button',
        tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex),
        target: computedTarget,
        'aria-disabled': disabled
      }),
      wrappedChildren,
      truncate ? null : externalLinkIcon
    );

    return (0, _Links.renderSecurityTaggedLink)(href, renderedLink);
  }
});

exports.default = (0, _Translatable2.default)(UILink);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/link/UILink.js
// module id = 98
// module chunks = 0